import { createSlice } from "@reduxjs/toolkit";
import { getCompany } from "../reduxApi/companyReduxApi";

const companySlice = createSlice({
    name: 'company',
    initialState: {
        status: 'idel',
        isFiltered: false,
        company: [],
    },
    reducers: {
         setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },
        deleteCompanyAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.company.findIndex((item) => item.companies.ROWID === id);
                if (index !== -1) {
                    state.company.splice(index, 1);
                }
            });
        },
        updateCompanyAction: (state, action) => {
            // console.log("action", action.payload)
            const index = state.company.findIndex((item) => item.companies.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.company.splice(index, 1, { companies: action.payload })
            }
        },
        addCompanyAction: (state, action) => {
            const temp = action.payload.formData;
            temp.ROWID = action.payload.ROWID;
            state.company.unshift({ companies: temp });
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getCompany.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getCompany.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                state.company = action.payload.data.response;
            })
    }
})
export const { deleteCompanyAction, updateCompanyAction, addCompanyAction,setFilteredStatus } = companySlice.actions
export default companySlice.reducer